<!-- 发布管理 -->
<template>
  <div class="release-management">
    <div class="welcomeBanner" :style="backgroundUrl">
      <h2>欢迎使用视频点播服务</h2>
      <p>视频点播服务，大屏端的视频采集、编辑、上传、媒体资源管理、自动化转码处理（窄带高清TM）、视频审核分析、分发加速于一体的音视频点播服务。欢迎使用！</p>
    </div>
     <!-- 数据分析 三个平台 CMS VOD 一键打包 三个服务都有权限展示-->
     <Analyze v-if="servicesLength == 3"/>
     <!-- 数据统计-->
     <Statistics v-else/>
  </div>
</template>
<script>
import Analyze from './components/analyze.vue'
import Statistics from './components/statistics.vue'

export default {
  components: {
    Analyze,
    Statistics
  },
  data () {
    return {
      backgroundUrl: {
        backgroundImage: 'url(' + require('../../../assets/background_1.png') + ')'
      },
      servicesLength: this.$store.state.router.services.length
    }
  }
}
</script>
<style lang="less" scoped>
  @import "../../../assets/css/dataAnalysis.less";
</style>
